import { HttpParams, HttpResponse } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnumSiNoTodos } from '../../../core/_infrastructure/types/common';
import { FilterSearchingOrganismosNocivosViewModel, OrganismosNocivosItemResultsViewModel, OrganismosNocivosViewModel } from './organismosnocivos.types';

@Injectable()
export class OrganismosNocivosService {
    organismosNocivosEndpoint = this.baseUrl + 'api/core/organismosnocivos/';
    arrBooleanKeys = ['Preferred', 'Status', 'RegulatedUe', 'NoEspecie'];
    private lastSearch?: FilterSearchingOrganismosNocivosViewModel;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    private convertModelToHttpParms(payload: FilterSearchingOrganismosNocivosViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingOrganismosNocivosViewModel;

        for (k in payload) {
            let v;
            let valor = payload[k];
            if (this.arrBooleanKeys.indexOf(k) !== -1 && valor == EnumSiNoTodos.NO) {
                v = 0;
            } else {
                v = payload[k] || '';
            }
            params = params.append(k, v);
        }

        return params;
    }

    getOrganismosNocivos(payload: FilterSearchingOrganismosNocivosViewModel): Observable<OrganismosNocivosItemResultsViewModel> {
        this.lastSearch = payload; // Keep for future search
        const params = this.convertModelToHttpParms(payload);
        return this.getOrganismosNocivosPagedByFilter(params);
    }

    private getOrganismosNocivosPagedByFilter(params: HttpParams): Observable<OrganismosNocivosItemResultsViewModel> {
        return this.http.get<OrganismosNocivosItemResultsViewModel>(this.organismosNocivosEndpoint + 'pagedbyfilter/', { params: params });
    }

    getOrganismoNocivo(id: number): Observable<OrganismosNocivosViewModel> {
        return this.http.get<OrganismosNocivosViewModel>(this.organismosNocivosEndpoint + 'getbyid/' + id);
    }

    saveOrganismoNocivo(organismoNocivo: OrganismosNocivosViewModel): Observable<any> {
        if (organismoNocivo?.Id) {
            return this.editOrganismoNocivo(organismoNocivo);
        }
        return this.createOrganismoNocivo(organismoNocivo);
    }

    createOrganismoNocivo(organismoNocivo: OrganismosNocivosViewModel): Observable<any> {
        return this.http.post<OrganismosNocivosViewModel>(this.organismosNocivosEndpoint, organismoNocivo);
    }

    editOrganismoNocivo(organismoNocivo: OrganismosNocivosViewModel): Observable<any> {
        return this.http.put<OrganismosNocivosViewModel>(this.organismosNocivosEndpoint, organismoNocivo);
    }

    deleteOrganismoNocivo(id: number): Observable<any> {
        return this.http.delete<OrganismosNocivosViewModel>(this.organismosNocivosEndpoint + id);
    }

    exportOrganismoNocivo(model: FilterSearchingOrganismosNocivosViewModel): Observable<HttpResponse<Blob>> {
        return this.http.post(this.organismosNocivosEndpoint + 'postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' });
    }

    getLastSearch(): FilterSearchingOrganismosNocivosViewModel | undefined {
        return this.lastSearch;
    }

    clearLastSearch(): void {
        this.lastSearch = undefined;
    }
}
